module.exports = __webpack_public_path__ + "img/6_63.a9781ba9.png";